import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';

const AccountToBeDeletedNotification = ({ visible, notification, payRetentionFee, mutationIsLoading, hide }) => {
  const payNowButtonLabel = mutationIsLoading ? (
    <span>
      <i className="pi pi-spin pi-spinner" />
    </span>
  ) : (
    <span>PAY NOW</span>
  );
  const disregardAndContinueButtonLabel = mutationIsLoading ? (
    <span>
      <i className="pi pi-spin pi-spinner" />
    </span>
  ) : (
    <span>DISREGARD AND CONTINUE</span>
  );

  return (
    <Dialog
      header={`This account is deleted in ${notification.numberOfDaysUntilDeletion} days!`}
      dismissableMask={false}
      closable={false}
      blockScroll={true}
      visible={visible}
      onHide={() => {}}
      position="center"
    >
      {notification.canPayRetentionFee && (
        <>
          <p>{`If you want to retain the account, please pay the retention before the account is deleted. The retention fee is ${notification.retentionPrice} Credits.`}</p>
          <p>{`If you do not want to retain the account, you do not have to do anything as it is automatically and irrevocably deleted in ${notification.numberOfDaysUntilDeletion} days. Until it is deleted, you can use it with pre-existing data.`}</p>
          <div className="center">
            <Button
              type="button"
              disabled={mutationIsLoading}
              className="p-button-primary"
              label={payNowButtonLabel}
              onClick={payRetentionFee}
            />
            <Button
              type="button"
              disabled={mutationIsLoading}
              className="p-button-primary"
              label={disregardAndContinueButtonLabel}
              onClick={hide}
            />
          </div>
        </>
      )}
      {!notification.canPayRetentionFee && (
        <>
          <p>However, it is retained if the retention fee is paid by the organisation having the account.</p>
          <div className="center">
            <Button type="button" className="p-button-primary" label="GOT IT - CONTINUE" onClick={hide} />
          </div>
        </>
      )}
    </Dialog>
  );
};

export default AccountToBeDeletedNotification;
